export type BrandUploadResult = { asset: { id: string; url: string } };

export class BrandUploadError extends Error {
  constructor(message: string, readonly status?: number) { super(message); this.name = "BrandUploadError"; }
}

/** XHR exposes real byte progress; 100% means the server is validating/scanning. */
export function uploadBrandFile(origin: string, token: string, file: File, purpose: "logo" | "photo", onProgress?: (percent: number) => void): Promise<BrandUploadResult> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${origin}/api/brand/media`);
    xhr.timeout = 120_000;
    xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    xhr.setRequestHeader("Content-Type", file.type);
    xhr.setRequestHeader("X-Media-Permission", "confirmed");
    xhr.setRequestHeader("X-Media-Purpose", purpose);
    xhr.upload.onprogress = event => { if (event.lengthComputable) onProgress?.(Math.min(100, Math.round(event.loaded / event.total * 100))); };
    xhr.upload.onload = () => onProgress?.(100);
    xhr.onerror = () => reject(new BrandUploadError("The upload could not reach Kate. Check your connection and try again."));
    xhr.ontimeout = () => reject(new BrandUploadError("The image check took too long. Wait briefly before trying again."));
    xhr.onabort = () => reject(new BrandUploadError("Upload cancelled."));
    xhr.onload = () => {
      let body: unknown;
      try { body = JSON.parse(xhr.responseText); } catch { reject(new BrandUploadError("Kate returned an invalid upload response.")); return; }
      const result = body as { error?: string; asset?: { id?: unknown; url?: unknown } } | null;
      if (xhr.status < 200 || xhr.status >= 300) { reject(new BrandUploadError(typeof result?.error === "string" ? result.error : `Upload failed (${xhr.status})`, xhr.status)); return; }
      if (typeof result?.asset?.id !== "string" || typeof result.asset.url !== "string" || !result.asset.url.startsWith("https://")) { reject(new BrandUploadError("Kate returned an invalid upload response.")); return; }
      resolve({ asset: { id: result.asset.id, url: result.asset.url } });
    };
    xhr.send(file);
  });
}
